/**
 * For ADA - Append Buttons into the dots
 * @param {object} event
 */

function appendButtons() {
  const c = {
    dom: {
      dot: 'dot',
    },
    cls: {
      selected: 'is-selected',
    },
  };

  const items = document.querySelector('.js-index-carousel');
  const $dots = items ? items.querySelectorAll(`.${c.dom.dot}`) : null;

  /**
   * Init
   */
  function init() {
    if (!$dots) return;
    listButtons();
  }

  function listButtons() {
    $dots.forEach((dot, index) => {
      const selected = _.hasClass(dot, c.cls.selected);
      const number = index + 1;
      const label = `aria-label="Gallery dot ${number}"`;
      const innerHtml = `
        <button type="button" class="screenreader dot__btn" ${label}></button>
      `;

      dot.innerHTML = innerHtml.trim();

      if (selected) {
        dot.setAttribute('aria-current', true);
      } else {
        dot.removeAttribute('aria-current');
      }

      dot.addEventListener('transitionend', () => {
        const isSelected = _.hasClass(dot, c.cls.selected);
        if (isSelected) {
          dot.setAttribute('aria-current', true);
        } else {
          dot.removeAttribute('aria-current');
        }
      });

      dot.firstChild.addEventListener('keyup', (e) => {
        if (e.keyCode === 13) {
          e.preventDefault();
          dot.click();
        }
      });
    });
  }

  return init();
}

appendButtons();
